// One approved operational pilot. Server-side RPC guard enforces the same scope.
export const pilot = {
  "jobId": "657e537b-d042-4ca0-8562-399773605063",
  "quoteId": "0ea06d30-6fa5-41f4-bfb1-b09aae16f1fe",
  "quoteNumber": "51131",
  "lineId": "3tfas5vu2",
  "configurationKey": "main",
  "label": "Waikato Business Awards — AI Photo Booth",
  "adminStaffId": "90d7e632-969f-4547-9838-cd5f8390c8cc",
  "requiredKeys": [
    "AI Photo Booth: 1. Delivery Methods",
    "AI Photo Booth: 2. Guest Sharing & Download Options",
    "AI Photo Booth: 3. Live Event Gallery"
  ]
} as const;
export const isProgrammingPilot=(job:string,quote:string)=>job===pilot.jobId&&quote===pilot.quoteId;
